module.exports = __webpack_public_path__ + "img/Time.0eb4f9e7.svg";